export default {
  enabled: 'Enabled',
  disabled: 'Disabled',
  autoRedirect: 'Auto Redirect',
  isHistory: 'Is a history',
  titlePlaceholder: 'Enter title',
  urlPlaceholder: 'Enter redirect url...',
  checklist: 'Checklist',
  status: 'Status',
  sortBy: 'Sort by',
  sortByFormat: '{{field}} in {{type}} order',
  configHistory: 'Configure link as history',
  moveUp: 'Move Up',
  moveDown: 'Move Down',
  duplicate: 'Duplicate',
  remove: 'Remove',
  filterSelection: 'Filter selection',
  sort: 'Sort',
  field: 'Field',
  order: 'Order',
  filters: 'Filters',
  requiredChecklist: 'Checklist*',
  clearSelection: 'Clear selection',
  confirm: 'Confirm',
  addNewLink: 'Add new link',
  save: 'Save',
  sortOptions: {
    ID: 'Id',
    YEARLY_ID: 'Code',
    SCHEDULING: 'Scheduling date',
    END_DATE: 'Activity end date',
    START_DATE: 'Activity start date'
  },
  orderOptions: {
    ASC: 'Ascending',
    DESC: 'Descending'
  },
  validation: {
    fillAllNames: 'Please fill in all names',
    fillAllUrls: 'Please fill in all urls',
    fillChecklistForHistory: 'Please fill in the checklist for history',
    invalidUrls: 'There are invalid urls',
    multipleAutoRedirects: 'More than one automatic redirect is not allowed',
    confirmSaveWithoutCustomLink: 'Are you sure you want to save without custom link?'
  },
  customizeLinks: 'Customize links'
}
